import { BmBanksResponse } from "../models/bm-banks.resposne";
import { ConsentListItem, IAppConsentsModel } from "../models/settings/consent.fetch.model";
import { OffertResponse } from "../models/prepare.offert.model.dto";
import { AdditionalFormNames, FormNames } from '../models/form/IFormDefinition'
import { SEND_AGAIN_SMS_CODE_STATUSES, SMS_CODE_STATUSES } from './reducers/contract-sign-reducer'
import { IDropdownBooleanOption, IDropdownChangeIncomeFieldsOption, IDropdownOption } from '../components/form/Fields/InputDropdown/InputDropdownProps'
import { IncomeAdditionalFieldsNames, IncomeBasicFieldsNames } from '../formDefinitions/IncomeInfoForm/IncomeInfoFields'
import { AdditionalIncomeAdditionalFieldsNames, AdditionalIncomeBasicFieldsNames } from '../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'
import { BasicInfoFieldsNames } from '../formDefinitions/BasicInfo/BasicInfoFields'
import { ExtendedInfoFieldsNames } from '../formDefinitions/ExtendedInfo/ExtendedInfoFields'
import { AddressInfoFieldsNames } from '../formDefinitions/AddressInfoForm/AddressInfoFields'
import { CorrespondenceAddressInfoFieldsNames } from '../formDefinitions/AddressInfoForm/CorrespondenceAddressInfoFields'
import { affiliatePartnersNames } from '../pages/AffiliatePage/affiliatePartnersData'
import { IAnalyticsEventsTypesNamesResponse } from '../models/AnaliticsEventModels'
import { CUSTOM_CLIENT_OFFERS_NAMES } from '../pages/CustomClientOfferPage/customClientOffersConfig'
import { IContractDone } from '../models/credential-actions-models'
import { MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES } from '../pages/ManualVerificationPage/models/IManualVerificationPageModel'
import { IHubConnectionStatus } from '../common/hub-client'

export enum verificationCodeInputsNames {
  VERIFICATION_CODE_INPUT_1 = "VERIFICATION_CODE_INPUT_1",
  VERIFICATION_CODE_INPUT_2 = "VERIFICATION_CODE_INPUT_2",
  VERIFICATION_CODE_INPUT_3 = "VERIFICATION_CODE_INPUT_3",
  VERIFICATION_CODE_INPUT_4 = "VERIFICATION_CODE_INPUT_4",
  VERIFICATION_CODE_INPUT_5 = "VERIFICATION_CODE_INPUT_5",
  VERIFICATION_CODE_INPUT_6 = "VERIFICATION_CODE_INPUT_6",
}
export type TVerificationCodeInputsNamesModel = keyof typeof verificationCodeInputsNames
export interface IContractSignState{
  verificationCodeInputs: {
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_1]: string;
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_2]: string;
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_3]: string;
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_4]: string;
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_5]: string;
    [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_6]: string;
  }
  isLimit : boolean;
  hasError: boolean;
  hasSmsSendAgainError: boolean;
  sendedSmsCount: number;
  agreemenFileName: string;
  currentSmsCodeTextState: SMS_CODE_STATUSES | null;
  currentSendAgainSmsCodeTextState: SEND_AGAIN_SMS_CODE_STATUSES | null;
  currentFullSmsCode: string | null;
  currentClientPeselReservedErrorText: string | null;
}
export interface ISetVerificationCodeInputValueAction {
  inputName: TVerificationCodeInputsNamesModel;
  newValue: string;
}

export enum PREDEFINED_PERIODS_OFFER_LOGIC {
  SHORT_PERIOD = "SHORT_PERIOD",
  LONG_PERIOD = "LONG_PERIOD",
}

export interface ApplicationState{
  offert : OffertResponse;
  isLoading: boolean;
  isWaiting : boolean;
  banks: BmBanksResponse[];
  billingCompany : string;
  appId : string;
  amountToPay : number;
  isOffline : boolean;
  wasOffline: boolean;
  successReturnUrl: string;
  failureReturnUrl: string;
  waitingScreenText: string;
  kontomatikWidgetClient: string;
  kontomatikWidgetOwnerExternalId: string;
  applicationStatus: string;
  workflowId: number | null;
  affiliatePartnerIdFromTokenResponse: string | null;
  isConnected: boolean;
  isAppHasError: boolean;
  userTrappedOnPageUrlPath: string | undefined;
  userEmailFromHub: string | undefined;
  hubConnectionStatus: IHubConnectionStatus
  IS_PREDEFINED_PERIODS_AVAILABLE: boolean
  currentSelectedPredefinedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC | undefined;

  manualVerificationState:  {
    manualVerificationPageHubVerificationState?: MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES;
    hasClientConsentManualVerification: boolean;
    clientConsentManualVerificationHasError: boolean;
    contractDone: IContractDone;
    workFrom: string | undefined;
  }
}
export interface ConsentState{
  consent: ConsentListItem[];
  appConsents: IAppConsentsModel[];
}

export interface IRecalculateOffertHubData { //TODO - Zobaczyć użycia / poprawić
  requestedAmount: number;
  minimumLoanAmount: number;
  maxInstallmentNumber: number;
  minInstallmentNumber: number;
  offerId: string | undefined;
  maximumLoanAmount: number;
  instalments?: number;
  instalmentsAmount?: number;
  ckdz?: number;
  interestRate?: number;
  rrso?: number;
  isOk: boolean; 
}

export interface ISubmitChooseOfferData {
  requestedAmount: number;
  offerId: string | undefined;
  instalments?: number;
  instalmentsAmount?: number;
}

export interface IPredefinedSingleOfferResponse {
  id: number;
  offerId: string;
  name: PredefinedOfferNames;
  order: number;
  requestedAmount: number;
  instalments: number;
  instalmentsAmount: number;
  ckdz: number;
  interestRate: number;
  paymentDate: string;
  isRecommended: boolean;
}

export enum PREDEFINED_OFFERS_FETCH_TYPE {
  DEFAULT = "DEFAULT",
  PREDEFINED_PERIODS = "PREDEFINED_PERIODS",
}

export type PredefinedUserOfferObject = Record<PREDEFINED_PERIODS_OFFER_LOGIC, IPredefinedSingleOfferResponse[]>;

export interface IGetPredefinedOfferDTO {
  installmentNumber?: number;
  isPredefinedPeriodsAvailable?: boolean;
  predefinedPeriod?: PREDEFINED_PERIODS_OFFER_LOGIC;
}

// !!! IMPORTANT !!! ENUM MA SWÓJ ODPOWIEDNIK NA BACKENDZIE W PLIKU \otp-backend\src\OTP.Application\DTOS\Api\PredefinedOffersResponse.cs - PRZY ZMIANIE NALEŻY O TYM PAMIĘTAĆ
export enum PredefinedOfferNames {
  HIGHEST_OFFER = "HIGHEST_OFFER",
  REQUESTED_USER_OFFER = "REQUESTED_USER_OFFER",
  BONUS_OFFER = "BONUS_OFFER"
}

export enum APP_SOURCE_TYPES {
  STARTING_FORM = "Standarodwy proces",
  COMEBACK_PAGE = "Link powrotny",
  FROM_EXTERNAL_INTEGRATOR = "Zawnętrzny integrator"
}

export interface IGetCredentialsResponse {
  workflowId: number;
  userEmail:string;
  currentRequestedAmount: number;
  currentInstalments: number;
  currentInstalmentAmount: number | null;
  affiliatePartnerId: affiliatePartnersNames | null;
}
export interface IOfferState {
  requestedAmount: number;
  minimumLoanAmount: number;
  maxInstallmentNumber: number;
  minInstallmentNumber: number;
  offerId: string | undefined;
  instalments?: number;
  instalmentAmount?: number;
  ckdz?: number;
  interestRate?: number;
  rrso?: number;
  isOk: boolean; 
  paymentDate?: string;

  currentMaximumLoanAmount: number;
  currentSelectedInstallmentNumber: number;
  maximumLoanAmount_minimumInstallment: number | null;
  maximumLoanAmount_maximumInstallment: number;
  hasUserChangeAmount: boolean;
  currentCustomClientOffer: CUSTOM_CLIENT_OFFERS_NAMES | null;

  predefinedUserOffersArray?: IPredefinedSingleOfferResponse[];
  predefinedUserOffersObject?: PredefinedUserOfferObject;
  isCustomOfferOnly?: boolean;
  noOfRecalculation: number;
}
export interface IRecalculateOffert {
  requestedAmount: number | null;
  instalments: number | null;
  instalmentsAmount: number | null;
  maxInstallmentNumber: number | null;
  minInstallmentNumber: number | null;
  currentMaximumLoanAmount: number | null;
  minimumLoanAmount: number | null;
  maximumLoanAmount: number | null;
  ckdz: number | null;
  interestRate: number | null;
  rrso: number | null;
  offerId: string | null;
  paymentDate: string | null;
  isOk: boolean;
}

type ITextContentsNestedObject = {
  [key: string]: string | ITextContentsNestedObject;
}
export interface ITextContentState {
  errorPage: ITextContentsNestedObject | {};
  sessionEndPage: ITextContentsNestedObject | {};
  failPage: ITextContentsNestedObject | {};
  manualVerificationPage: ITextContentsNestedObject | {};
  contractSigningPage: ITextContentsNestedObject | {};
  bmVerifyPage: ITextContentsNestedObject | {};
  offertPage: ITextContentsNestedObject | {};
  buttons: ITextContentsNestedObject | {};
  modals: ITextContentsNestedObject | {};
  clientPeselReservedPage: ITextContentsNestedObject | {};
  contractDonePage: ITextContentsNestedObject | {};
  clientChoiceVerificationPage: ITextContentsNestedObject | {};
  videoVerificationStartPage: ITextContentsNestedObject | {};
  mObywatelIdentityPage: ITextContentsNestedObject | {};
  loaders: ITextContentsNestedObject | {};
  customClientOfferPage: ITextContentsNestedObject | {};
  predefinedOfferPage: ITextContentsNestedObject | {};
}

export interface ILoaderConfigObjectModel {
  heading: string;
  description: string;
  from: number;
  to: number | null;
}


// !!! IMPORTANT - nazwy muszą odpowiadać kluczą z bazy mongo - otp_config => config.json => loadersConfig
export enum LOADER_CONFIG_KEYS {
  OFFER_WAITING = "offerWaiting",
  BM_WAITING = "bmWaiting"
}

export interface SliderStep {
  from: number;
  value: number
}

export interface ILeadBaseLinkObject {
  link: string;
  id: string;
}
export interface ILenConfigState {
  footerConfig: {
    phoneNumber: string;
    isPhoneAvailable: boolean;
    isPhoneVisibleOnPage: boolean;
    officeOpenTime: string;
    officeClosedTime: string;
  };
  globalConfig: {
    invalidNipNumbers: string[];
    invalidPeselNumbers: string[];
    sendSmsBlockingTimeInMs: number;
    sendSmsInitialBlockingTime: number;
    sendSmsLimit: number;
    minimumLoanAmount: number;
    defaultOfferSliderSteps: SliderStep[];
    manualVerificationPhoneNumber: string;
    mObywatelCodeValidationTimeInSeconds: number;
    metaPixelEnabled: boolean;
    affiliateCookieExpiresTimeInHours: Record<affiliatePartnersNames, number> | undefined;
    leadBaseLinks: { [key: string]: ILeadBaseLinkObject};
    leadRedirectionDelayInSeconds: number;
    clientPeselReservedCheckBlockingTimeInSec: number;
    workTimeFrom: { hours: number, minutes: number};
    workTimeTo: { hours: number, minutes: number};
  };
  loadersConfig: {
    [LOADER_CONFIG_KEYS.OFFER_WAITING]: ILoaderConfigObjectModel[];
    [LOADER_CONFIG_KEYS.BM_WAITING]: ILoaderConfigObjectModel[];
  };
  analyticsEventTypesNames?: IAnalyticsEventsTypesNamesResponse;
}

export interface ILoanCalculatorState{
  requestedAmount : number;
  instalments : number;
  minLoanAmount: number;
  maxLoanAmount: number;
  minLoanPeriod: number;
  maxLoanPeriod: number;
  requestedAmountSteps: SliderStep[];
  instalmentAmount: number;
  ckdz:  number;
  interestRate: number;
  rrso: number;

  isOffertReady: boolean;
  isCalculatorOpen: boolean;
  isOffertAlreadySet: boolean;
  noOfCalculation: number;
}
export interface ILoanCalculatorRecalculate{
  requestedAmount : number ;
  instalments : number ;
  instalmentsAmount: number;
  ckdz:  number;
  interestRate: number;
  rrso: number;
}


export interface IVideoVerificationState {
  sessionId: string;
  documentId: string;
  videoVerificationUrl: string;
}


// ==================================== FORM STATE TYPES ========================================
export type IFieldsDataStateFieldValue = string | boolean | number | IDropdownOption | IDropdownBooleanOption | IDropdownChangeIncomeFieldsOption | undefined;

export interface IFieldsDataStateValue {
   value: string | number | boolean;
   fieldState: IFieldsDataStateFieldValue;
   validationError: string | undefined | null; // Undefined - wartość początkowa, użytkownik nic nie wpisał w kontrolkę. Null - użytkownik wpisał poprawną wartość w kontrolkę. String - komunikat z błędem
}

export type IFieldsDataState<T extends Record<string, string>> = {
   [key in keyof T]: IFieldsDataStateValue;
};


export interface IFormConfigState {
   isAdditionalFormOpen?: boolean;
   currentIncomeInfoFields?: Partial<IncomeAdditionalFieldsNames>[] | Partial<AdditionalIncomeAdditionalFieldsNames>[];
}

// =================================================================================================================================

export interface IFormState<T extends Record<string, string>> {
   fieldsData: IFieldsDataState<T>; // T specifies the fields for each form
   formConfig: IFormConfigState | null;
}

export interface AllFormsState {
   [FormNames.BasicInfoForm]: IFormState<typeof BasicInfoFieldsNames>;
   [FormNames.ExtendedInfoForm]: IFormState<typeof ExtendedInfoFieldsNames>;
   [FormNames.AddressInfoForm]: IFormState<typeof AddressInfoFieldsNames>;
   [FormNames.IncomeInfoForm]: 
      | IFormState<typeof IncomeBasicFieldsNames>
      | (IFormState<typeof IncomeBasicFieldsNames> & Partial<IFormState<typeof IncomeAdditionalFieldsNames>>);

   [AdditionalFormNames.CorrespondenceAddressForm]?: IFormState<typeof CorrespondenceAddressInfoFieldsNames>;
   [AdditionalFormNames.AdditionalIncomeForm]?: 
      | IFormState<typeof AdditionalIncomeBasicFieldsNames>
      | (IFormState<typeof AdditionalIncomeBasicFieldsNames> & Partial<IFormState<typeof AdditionalIncomeAdditionalFieldsNames>>);

   globalFormConfig: {
      currentOpenedAdditionalForms: Partial<AdditionalFormNames>[]
   }
}